import { createFileRoute } from '@tanstack/react-router';
import { EditDynamicTemplatePage } from '../features/templates/dynamic-template-studio-page';
export const Route = createFileRoute(
  '/manage/$companySlug/templates_/$templateId/versions/$version/edit',
)({ component: RouteComponent });
function RouteComponent() {
  const { companySlug, templateId, version } = Route.useParams();
  return (
    <EditDynamicTemplatePage
      companySlug={companySlug}
      templateId={templateId}
      version={Number(version)}
    />
  );
}
